import { useQuery } from "@tanstack/react-query";
import { parseAsString, useQueryStates } from "nuqs";

import { FullScreenLoader } from "../components/ui/loaders/full-screen-loader.jsx";
import { MeetingSidePanel } from "../components/ui/meeting-side-panel/meeting-side-panel.jsx";
import { channelTabList } from "../services/api.service.js";

export const MeetingSidePanelPage = () => {
  const [{ msTeamId, channelUuid }] = useQueryStates({
    channelUuid: parseAsString,
    msTeamId: parseAsString,
  });

  const { data, isLoading } = useQuery({
    enabled: !!(msTeamId && channelUuid),
    queryFn: () => {
      if (!channelUuid) {
        throw new Error("channelUuid is required");
      }
      return channelTabList({ channelUuid });
    },
    queryKey: ["channelTabList", msTeamId, channelUuid],
  });

  if (isLoading) {
    return <FullScreenLoader message="Loading meeting side panel..." />;
  }

  // Show error if no channel data found
  if (!(data && channelUuid)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
        <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-lg">
          <h1 className="mb-4 text-2xl font-semibold text-gray-900">
            Configuration Required
          </h1>
          <p className="text-gray-600">
            This meeting side panel has not been configured yet. Please
            configure it first to access BeZoned content.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-screen flex-col bg-white">
      <MeetingSidePanel
        channelUuid={channelUuid}
        displayName={data.table.displayName}
        msChannelId={data.msChannelId}
        tabs={data.tabs}
      />
    </div>
  );
};
